export default __webpack_public_path__ + "static/media/highlight-8-new.df677ffa.png";